export const ManageMySiteViewTestIDs = {
  header: {
    title: 'manage-site-header-title',
    editButton: 'manage-site-edit-button',
    closeButton: 'manage-site-close-button',
  },
  profile: {
    imageContainer: 'coach-profile-image-container',
    image: 'coach-profile-image',
  },
  website: {
    linkContainer: 'website-link-url-container',
    linkText: 'website-link-url-test',
    noUrlContainer: 'no-website-url-container',
    noUrlText: 'no-website-url-text',
  },
  about: {
    container: 'about-me-text-container',
    text: 'about-me-text',
    readMoreToggle: 'read-more-toggle',
    readMoreToggleText: 'read-more-toggle-text',
    readMoreIcon: 'read-more-toggle-icon',
  },
  social: {
    linkLabel: (platform: string, index: number) =>
      `social-link-label-${platform}-${index}`,
    linkButton: (platform: string, index: number) =>
      `social-link-button-${platform}-${index}`,
    linkText: (platform: string, index: number) =>
      `social-link-text-${platform}-${index}`,
    editAllButton: 'edit-social-links-button',
    noLinksText: 'no-social-links-text',
    noLinksContainer: 'no-social-links-container',
    error: 'social-media-error',
    errorText: 'social-media-error-text',
  },
  photos: {
    section: 'transformation-photos-section',
    beforeLabel: 'before-photo-label',
    beforeContainer: 'before-photo-container',
    beforeImage: 'before-photo-image',
    afterLabel: 'after-photo-label',
    afterContainer: 'after-photo-container',
    afterImage: 'after-photo-image',
  },
};

export default ManageMySiteViewTestIDs;
